let form = {
    "labels": {
      "title": "Titel",
      "description": "Beschrijving",
      "phone": "Telefoonnummer",
      "email": "E-mailadres",
      "address": "Adres",
      "product": "Product",
      "product_title": "Titel",
      "quantity": "Hoeveelheid",
      "price": "Prijs",
      "price_type": "Eenheid",
      "price_per_unit": "Prijs per eenheid",
      "vat_option": "BTW",
      "total": "Totaal",
      "name": "Naam",
      "first_and_last_name": "Voor- en achternaam",
      "honorific": "Beleefdheid",
      "phone_number": "Telefoon",
      "address_line_1": "Adresregel 1",
      "address_line_2": "Adresregel 2",
      "postal_code": "Postcode",
      "city": "Stad",
      "country": "Land",
      "comments": "Opmerkingen",
      "is_professional": "Professionele klant",
      "vat_number": "BTW-nummer",
      "vat_option_id": "BTW",
      "default_vat_option_id": "standaard BTW",
      "category_id": "Categorie",
      "price_type_id": "Eenheid",
      "percentage": "Percentage",
      "payment_date": "Vervaldatum",
      "payment_communication": "Betalingsinstructie",
      "valid_until": "Geldigheidsdatum",
      "paid_at": "Datum van betaling",
      "discount": "Korting",
      "subject": "Onderwerp",
      "email_subject": "Onderwerp van de e-mail",
      "email_text": "Tekst van de e-mail",
      "email_to": "Ontvanger",
      "email_copy": "Stuur mij een kopie per e-mail",
      "status": "Status",
      "amount": "Bedrag",
      "company_name": "Bedrijfsnaam",
      "company_email": "E-mailadres",
      "company_phone_number": "Telefoon",
      "company_vat": "BTW-nummer",
      "company_vat_number": "BTW-nummer",
      "company_address_line_1": "Adresregel 1",
      "company_address_line_2": "Adresregel 2",
      "company_postal_code": "Postcode",
      "company_city": "Stad",
      "company_country": "Land",
      "company_logo": "Logo",
      "client_id": "Klant",
      "client_name": "Naam klant",
      "client_email": "E-mailadres",
      "client_phone_number": "Telefoon",
      "client_vat_number": "BTW-nummer",
      "client_address_line_1": "Adresregel 1",
      "client_address_line_2": "Adresregel 2",
      "client_postal_code": "Postcode",
      "client_city": "Stad",
      "client_country": "Land",
      "client_reminder_1_enabled": "Activeer de eerste betalingsherinnering voor deze klant",
      "client_reminder_2_enabled": "Activeer de tweede betalingsherinnering voor deze klant",
      "client_reminder_3_enabled": "Activeer de derde betalingsherinnering voor deze klant",
      "invoice_title": "Referentie",
      "invoice_files": "Verwante bestanden",
      "invoice_number_prefix": "Voorvoegsel",
      "invoice_number_prefix_custom": "Aangepast voorvoegsel",
      "current_year": "Jaar",
      "invoice_number_format": "Formaat",
      "invoice_number_demo": "Voorbeeld",
      "invoice_number_starts_at": "Begin van nummering",
      "invoice_number_starts_at_year": "Pas deze nummering toe op het jaar",
      "invoice_number_starts_at_month": "Pas deze nummering toe op de maand",
      "invoice_send_email_subject": "Onderwerp van de e-mail",
      "invoice_send_email_text": "Tekst van de e-mail",
      "invoice_send_email_copy": "Stuur mij een kopie per e-mail",
      "invoice_payment_delay": "Standaard betalingstermijn",
      "invoice_payment_delay_type": null,
      "invoice_iban_number": "IBAN",
      "invoice_bic": "BIC",
      "invoice_payment_communication_type": "Soort communicatie",
      "invoice_number": "Factuurnummer",
      "structured_communication": "Gestructureerde communicatie",
      "invoice_payment_communication_type_custom": "Gepersonaliseerde communicatie",
      "invoice_payment_communication": "Standaard betalingsinstructie",
      "invoice_extra_pdf": "PDF",
      "invoice_display_custom_start": "Verander het begin van de nummering",
      "quote_decline_reason": "Reden voor afwijzing",
      "quote_validity_delay": "Standaard geldigheidsduur",
      "quote_conditions": "Voorwaarden van de offerte",
      "reminder_enabled": "Activeer dit herinneringsniveau",
      "reminder_value": "Dagen na de vervaldag",
      "reminder_email_subject": "Onderwerp van de e-mail",
      "reminder_email_text": "Tekst van de e-mail",
      "reminder_email_copy": "Stuur mij een kopie van deze e-mail",
      "display_primary_color": "Hoofdkleur",
      "display_secondary_color": "Secundaire kleur",
      "card_number": "Kaartnummer",
      "card_expiry": "Vervaldatum",
      "card_cvv": "CVV",
      "cocontractor": "BTW Medecontractant",
      "next_invoice_number": "Factuurnummer",
      "next_quote_number": "Citaat nummer",
      "next_credit_note_number": "Kredietnota nummer",
      "record_payment_predefined_title": "Titel",
      "record_payment_custom_title": "Titel",
      "invoice_template": "Voorbeeld van een document",
      "image_uploader_button": "Upload een afbeelding...",
      "image_uploader_button_multiple": "Upload afbeeldingen...",
      "image_uploader_button_more": "Laat nog een beeld vallen...",
      "image_uploader_button_more_multiple": "Stuur andere beelden...",
      "image_uploader_button_replace": "Laat vallen om het beeld te vervangen...",
      "image_uploader_button_replace_multiple": "Laat vallen om beelden te vervangen...",

      file_uploader_button: 'Document toevoegen',
      file_uploader_button_multiple: 'Document toevoegen',
      file_uploader_button_selected: "Je document is toegevoegd",
      file_uploader_button_selected_multiple: "Een document geselecteerd | {count} documenten geselecteerd",
      contacts: {
        title: "Contact",
        type: "Soort contact",
        name: "Naam van het contact"
      },
    },
    "placeholders": null,
    "messages": {
      "image_uploader_confirm_image_replacement": "Weet je zeker dat je de huidige afbeelding wilt vervangen?",
      "image_uploader_wrong_image_type": "Het bestandsformaat is niet geldig als afbeelding."
    },
    "buttons": {
      "create": "Aanmaken",
      "edit": "Bewerken"
    },
    "variables": {
      "invoicenumber": "Factuurnummer",
      "quotenumber": "Citaat nummer",
      "creditnotenumber": "Kredietnota nummer",
      "communication": "Communicatie",
      "invoiceamount": "Bedrag van de factuur",
      "quoteamount": "Bedrag van de raming",
      "creditnoteamount": "Bedrag van de creditnota",
      "invoiceremainingamount": "Resterende saldo van de factuur",
      "creditnoteremainingamount": "Resterende saldo van de creditnota",
      "iban": "IBAN",
      "bic": "BIC",
      "invoicedate": "Datum van factuur",
      "quotedate": "Datum offerte",
      "creditnotedate": "Datum van de kredietnota",
      "duedate": "Vervaldatum",
      "validitydate": "Geldigheidsdatum",
      "companyname": "Bedrijf"
    },
    "options": {
      "invoice_number_prefix": {
        "none": "Geen voorvoegsel",
        "custom": "Aangepast voorvoegsel",
        "year": "Lopend jaar",
        "year2": "Huidig jaar (laatste twee cijfers)"
      },
      "invoice_number_format": {
        "1": "Een cijfer",
        "2": "Twee cijfers",
        "3": "Drie cijfers",
        "4": "Vier cijfers",
        "5": "Vijf cijfers."
      },
      "invoice_number_starts_at_month": {
        "1": "Januari",
        "2": "Februari",
        "3": "Maart",
        "4": "April",
        "5": "Mei",
        "6": "Juni",
        "7": "Juli",
        "8": "Augustus",
        "9": "September",
        "10": "Oktober",
        "11": "November",
        "12": "December",
        "none": "Gebruik geen aangepaste start per maand"
      },
      "invoice_payment_delay_type": {
        "sent": "Dagen tot factuurdatum",
        "month": "Einde maand dagen"
      },
      "invoice_payment_communication_type": {
        "invoice_number": "Factuurnummer",
        "structured_communication": "Gestructureerde communicatie",
        "custom": "Gepersonaliseerd"
      },
      "quote_validity_delay_type": {
        "sent": "Dagen offerte datum"
      },
      "record_payment_title": {
        "total_payment": "Betaling van het saldo",
        "down_payment": "Voorschot",
        "partial_payment": "Gedeeltelijke betaling",
        "other": "Andere"
      },
      "invoice_template": {
        "default": "Klassiek",
        "tiny": "Tiny",
        "condensed": "Gecondenseerd",
        "flat-out": "Helemaal uit."
      }
    },
    "helpers": {
      "cocontractor": "Toont \"* BTW verlegd\" op documenten die één of meer elementen met dit BTW-tarief bevatten."
    }
};

form.placeholders = form.labels;
form.placeholders.select = 'Kies een optie';

export default form;